import { services } from '../../content/services.js';
import { ServiceTile } from './ServiceTile.js';

export function ServiceLauncher() {
  return (
    <section
      id="services"
      style={{
        maxWidth: '1180px',
        margin: '0 auto',
        padding: 'clamp(32px,5vw,54px) clamp(18px,5vw,64px) 0',
      }}
    >
      <div class="service-launcher-grid">
        {services.map((service, index) => (
          <ServiceTile key={service.key} service={service} index={index} />
        ))}
      </div>
    </section>
  );
}
